import React from 'react';
import { ChallengeInterface } from "src/store/mine_craft/challengesSlice";

import { RightSidebar } from "../../../_partials/Layout";
import { Tag } from 'antd';
import Countdown from "src/componets/Statistic/Countdown";
import { CheckCircleOutlined, ClockCircleOutlined, SyncOutlined } from '@ant-design/icons';

const _SidebarShow = ({ challenge }: { challenge: ChallengeInterface | undefined }) => {
  const Tags = ({ tags }: { tags: string[] | undefined }) => {
    if (!tags) return null;

    return (
      <>
        {tags.map((tag, index) => ( <Tag key={index} color='default'>{tag}</Tag> ) )}
      </>
    )
  }

  const Difficulty = ({ difficulty }: { difficulty: string | undefined }) => {
    if (!difficulty) return null;

    let color: string;
    switch (difficulty) {
      case 'easy':
        color = 'warning';
        break;
      case 'medium':
        color = 'success';
        break;
      case 'hard':
        color = 'error';
        break;
      case 'expert':
        color = 'red';
        break;
      default:
        color = 'default';
    }

    return <Tag color={color}>{difficulty}</Tag>;
  }

  const JobStatus = ({ job_status }: { job_status: string | undefined }) => {
    if (!job_status) return null;

    let color: string;
    let icon: React.ReactNode;

    switch (job_status) {
      case 'waiting':
        color = 'default';
        icon = <ClockCircleOutlined />;
        break;
      case 'processing':
        color = 'processing';
        icon = <SyncOutlined spin />;
        break;
      case 'done':
        color = 'success';
        icon = <CheckCircleOutlined />
        break;
      default:
        color = 'default';
        icon = null;
    }

    return <Tag icon={icon} color={color}>{job_status}</Tag>;
  }

  return (
    <RightSidebar>
      <h6 className='v-content-label'>CHOOSE OPTION</h6>
      <hr className="v-divider" />

      <h6 className="v-content-label o-sm v-mt">End in</h6>
      <Countdown value={challenge?.end_at} />

      <h6 className="v-content-label o-sm v-mt-15">Difficulty</h6>
      <Difficulty difficulty={challenge?.difficulty} />

      <h6 className="v-content-label o-sm v-mt-15">Filters</h6>
      <Tags tags={challenge?.filters} />

      <h6 className="v-content-label o-sm v-mt-15">Rules</h6>
      <div style={{whiteSpace: "pre-wrap"}}>
        {challenge?.rules}
      </div>

      <h6 className="v-content-label o-sm v-mt-15">Job Status</h6>
      <JobStatus job_status={challenge?.job_status} />
    </RightSidebar>
  )
}

export default _SidebarShow;
